import { render, staticRenderFns } from "./immersion03.vue?vue&type=template&id=4e460166&scoped=true&"
import script from "./immersion03.vue?vue&type=script&lang=js&"
export * from "./immersion03.vue?vue&type=script&lang=js&"
import style0 from "./immersion03.vue?vue&type=style&index=0&id=4e460166&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e460166",
  null
  
)

export default component.exports